module.exports = __webpack_public_path__ + "media/images/pause-5e735e6ee834d56f80e8146bdb59628f.png";